import React, { FormEvent, useState } from "react";
import { Product } from "../types/products.types";

interface ProductsEditFormProps {
  product: Product;
  onDelete: (id: number) => Promise<void>;
  onCancel: () => void;
}

const ProductDeleteModal: React.FC<ProductsEditFormProps> = ({
  product,
  onDelete,
  onCancel,
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setIsDeleting(true);
    setError(null);
    try {
      await onDelete(product.id);
    } catch (err: any) {
      setError(err.message || "Failed to save product.");
    } finally {
      setIsDeleting(false);
    }
  };

  const buttonContainerStyle: React.CSSProperties = {
    marginTop: "20px",
  };

  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "white",
        padding: "30px",
        borderRadius: "8px",
        boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
        zIndex: 1000,
        width: "90%",
        maxWidth: "600px",
        maxHeight: "90vh",
        overflowY: "auto",
      }}
    >
      <div style={{ marginBottom: "20px", textAlign: "center" }}>
        <h3>Sei sicuro di eliminare?</h3>
        <h2>
          {product.name} (ID: {product.id})
        </h2>
        <h6>Cliccando su Si Cancella l'azione sarà irreversibile</h6>
      </div>
      <form onSubmit={handleSubmit} style={{ textAlign: "center" }}>
        {error && <p style={{ color: "red" }}>{error}</p>}
        <div style={buttonContainerStyle}>
          <button
            type="submit"
            disabled={isDeleting}
            style={{ marginRight: "10px", padding: "10px 15px" }}
          >
            {isDeleting ? "Salvataggio..." : "Si Cancella"}
          </button>
          <button
            type="button"
            onClick={onCancel}
            disabled={isDeleting}
            style={{ padding: "10px 15px" }}
          >
            Annulla
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProductDeleteModal;
